// extracted by mini-css-extract-plugin
export var lockIcon = "LockIcon-module__lockIcon___Q6iyw";